import classNames from "classnames";
import type React from "react";
import { twMerge } from "tailwind-merge";

interface ColumnProps extends React.PropsWithChildren<React.ComponentPropsWithoutRef<"div">> {
  className?: React.ComponentPropsWithoutRef<"div">["className"];
  center?: boolean;
}

function Column({ className, center, ...props }: ColumnProps) {
  return (
    <div
      className={twMerge(
        classNames("flex min-h-full flex-col", center && "items-center justify-center", className)
      )}
      {...props}
    ></div>
  );
}

export default Column;
